import _enum from "@/enum/enum";
import dataFake from "@/data/dataFake";
import moment from "moment";
import { store } from "@/store/store"; // import your Vuex store
const keyCulture = "lang";

export default {
  getScreenType() {
    let width = window.innerWidth;
    if (width <= 450) return _enum.ScreenType.Mobile;
    else if (width <= 1024) return _enum.ScreenType.Tablet;
    return _enum.ScreenType.Computer;
  },

  getDataFake() {
    return dataFake;
  },

  getLinkViewGoogleDrive(id) {
    return `https://drive.google.com/thumbnail?id=${id}`;
  },
  formatDate(value, format = "DD/MM/YYYY") {
    return moment(value).format(format);
  },

  isTokenExpired() {
    const token = localStorage.getItem("Jwt");
    const expiresAt = localStorage.getItem("expires_at");
    let isTokenExpired =
      !expiresAt || isNaN(Number(expiresAt)) || Date.now() > expiresAt;
    store.commit("updateIsTokenExpired", isTokenExpired);
    if (!token || isTokenExpired) {
      this.logOutClear();
    }
    return isTokenExpired;
  },

  logOutClear() {
    store.commit("updateIsTokenExpired", true);
    localStorage.removeItem("Jwt");
    localStorage.removeItem("expires_at");
    localStorage.removeItem("userId");
    // store.commit('updateMenuActive', {
    //     text: "Trang chủ",
    //     router: "/",
    // });
    // router.push({ path: '/' });
  },

  async getBase64FromImage(file) {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => resolve(reader.result);
      reader.onerror = (error) => reject(error);
    });
  },

  async getFileToByte(file) {
    return new Promise((resolve, reject) => {
      try {
        let reader = new FileReader();
        let fileByteArray = [];
        reader.readAsArrayBuffer(file);
        reader.onloadend = (evt) => {
          if (evt.target.readyState == FileReader.DONE) {
            let arrayBuffer = evt.target.result,
              array = new Uint8Array(arrayBuffer);
            if (array && array.length > 0) {
              array.forEach((byte) => {
                fileByteArray.push(byte);
              });
            }
          }
          resolve(fileByteArray);
        };
      } catch (e) {
        reject(e);
      }
    });
  },

  setLanguageToCached(lang) {
    localStorage.setItem(keyCulture, lang);
  },

  getLanguageToCached() {
    let result = localStorage.getItem(keyCulture);
    return result === "en" ? "en" : "vi";
  },

  generateUUID() {
    // Generate a random UUID according to RFC4122 version 4
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
      const r = (Math.random() * 16) | 0;
      const v = c === 'x' ? r : (r & 0x3) | 0x8;
      return v.toString(16);
    })
  },

  sortColumn(a, b) {
    return (a?.length || 0) - (b?.length || 0) || (a || '').localeCompare(b || '')
  }
};
